export default function TrainingPresentationController(
  utilityService
) {
  const vm = this;
  vm.media.thumbnailUrl = utilityService.sanitizeImageSrc(vm.media.thumbnailUrl);
}

TrainingPresentationController.$inject = [
  'utilityService'
];
